export default __webpack_public_path__ + "locales/es/ChangeEmailDialog.json?hash=cf0484504bd600ae79f721fc33334b2d";